// authtoken export
export const authToken = () => {
  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjY1ODE3N2M0YWY4YWYxYjJlOGYzYTU2ZCJ9LCJ0eXBlIjoiYWNjZXNzVG9rZW4iLCJpYXQiOjE3MDYyNzY3MTMsImV4cCI6MTcwNjM2MzExM30.ZhecPnBdaZL_EnNmpfgvavT4vvJRd8x_rIoZ7fmnwbI";

  return `Bearer ${token}`;
};

export const authTokenWithoutBearer = () => {
  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjY1ODE3N2M0YWY4YWYxYjJlOGYzYTU2ZCJ9LCJ0eXBlIjoiYWNjZXNzVG9rZW4iLCJpYXQiOjE3MDYyNzY3MTMsImV4cCI6MTcwNjM2MzExM30.ZhecPnBdaZL_EnNmpfgvavT4vvJRd8x_rIoZ7fmnwbI";
  return `${token}`;
};
// authtoken export
export const loggedInUser = () => {
  const id = "658177c4af8af1b2e8f3a56d";

  return `${id}`;
};
